module.exports = __webpack_public_path__ + "static/11-049e371883a953a4eb85181881cef1ae.jpg";